export const MUTATIONS_LOCALE = {
  SET_LOCALE: 'SET_LOCALE'
};

export default {
  [MUTATIONS_LOCALE.SET_LOCALE](state, locale) {
    state.locale = locale;
  }
};
